import React from 'react';

import {
    Table,
    Button,
    Card,
    message
} from 'antd';

import NewVmSupplierModal from './modal';

import {
    _getVmSuppliers,
    _postRemoveVmSupplier,
} from '../../services'

class VmSupplierManager extends React.Component {

    constructor(props){
        super(props)
        this.state = {
            vmSupplierData: [],

            newVmSupplierModalVisible: false
        }
    }

    render() {
        return (
            <Card
            title={
                <Button onClick={this.handleNewVmSupplierClicked}>New VM Supplier</Button>
            }>
                {this.renderVmSupplierTable()}

                {this.state.newVmSupplierModalVisible && <NewVmSupplierModal 
                    newVmSupplierModalVisible={this.state.newVmSupplierModalVisible}
                    closeVmSupplierModal={this.closeVmSupplierModal}
                    />}
            </Card>
        )
    }

    componentDidMount() {
        this.getVmSuppliers()
    }

    getVmSuppliers = () => {
        _getVmSuppliers()
        .then(_vmSuppliers => {
            this.setState({
                vmSupplierData: _vmSuppliers.data
            })
        })
    }

    renderVmSupplierTable = () => {

        const columns = [{
            title: 'Email',
            dataIndex: 'userEmail'
        },{
            title: 'Created By',
            dataIndex: 'createdByEmail'
        },{
            title: 'Actions',
            render: (record) => <Button type='danger' onClick={() => this.handleDeleteClicked(record.userId)}>Delete</Button>
        }]

        return (
            <Table
                columns={columns}
                dataSource={this.state.vmSupplierData}
                pagination={false}
                />
        )
    }

    handleNewVmSupplierClicked = () => {
        this.setState({
            newVmSupplierModalVisible: true
        })
    }

    handleDeleteClicked = (vmSupplierId) => {
        console.log({vmSupplierId})
        _postRemoveVmSupplier({supplierId: vmSupplierId})
        .then(_vmSupplier => {
            this.getVmSuppliers()
            message.success('Removed successfully')
        })
        .catch(err =>{
            message.error('There was an error. Please try again')
        })
    }
    

    closeVmSupplierModal = () => {
        this.setState({
            newVmSupplierModalVisible: false
        },this.getVmSuppliers)
    }
}

export default VmSupplierManager


// WEBPACK FOOTER //
// ./src/components/vm-supplier/manager.js